import { render } from "./App.vue?vue&type=template&id=1f0ebd8b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1f0ebd8b&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__